import { gql } from '@apollo/client'

export const PRODUCT_FRAGMENT = gql`
  fragment ProductFragment on Product {
    id
    identificationToken
    legalFees
    price
    monthlyPrice
    yearlyPrice
    twoYearlyPrice
  }
`
